import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getAuth, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { doc, setDoc, getDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase.config';
import { toast } from 'react-toastify';
import { FaGoogle } from 'react-icons/fa';

function OAuth() {
  const navigate = useNavigate();
  const location = useLocation();

  const onGoogleClick = async e => {
    try {
      const auth = getAuth();
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      // Check for user
      const docRef = doc(db, 'users', user.uid);
      const docSnap = await getDoc(docRef);

      // If user doesn't exist, create user
      if (!docSnap.exists()) {
        await setDoc(doc(db, 'users', user.uid), {
          name: user.displayName,
          email: user.email,
          timestamp: serverTimestamp(),
        });
      }

      navigate('/my-library');
    } catch (error) {
      toast.error('Could not authorize with Google');
    }
  };

  return (
    <div className="google-box__top u-margin-top-bottom-l ">
      <h5 className="heading-5 u-margin-bottom-m">
        {location.pathname === '/login' ? 'Log In' : 'Register'} with
      </h5>

      <FaGoogle className="icon icon__login" onClick={onGoogleClick} />
    </div>
  );
}

export default OAuth;
